export const getWeatherDescription = (code) => {
    const weatherDescriptions = {
        0: ['Soleado', 'sunny'],
        1: ['Mayormente soleado', 'sunny'],
        2: ['Parcialmente nublado', 'sunny'],
        3: ['Nublado', 'cloud'],
        45: ['Niebla', 'wave'],
        48: ['Niebla con escarcha', 'wave'],
        51: ['Llovizna ligera', 'rain'],
        53: ['Llovizna moderada', 'rain'],
        55: ['Llovizna intensa', 'rain'],
        56: ['Llovizna helada ligera', 'rain'],
        57: ['Llovizna helada intensa', 'rain'],
        61: ['Lluvia ligera', 'rain'],
        63: ['Lluvia moderada', 'rain'],
        65: ['Lluvia intensa', 'rain'],
        66: ['Lluvia helada ligera', 'rain'],
        67: ['Lluvia helada intensa', 'rain'],
        71: ['Nieve ligera', 'snow'],
        73: ['Nieve moderada', 'snow'],
        75: ['Nieve intensa', 'snow'],
        77: ['Cristales de hielo', 'sunny'],
        80: ['Chubascos ligeros', 'rain'],
        81: ['Chubascos moderados', 'rain'],
        82: ['Chubascos intensos', 'rain'],
        85: ['Chubascos de nieve ligera', 'rain'],
        86: ['Chubascos de nieve intensa', 'rain'],
        95: ['Tormenta', 'rain'],
        96: ['Tormenta con granizo ligero', 'rain'],
        99: ['Tormenta con granizo intenso', 'rain'],
    };
    return weatherDescriptions[code] || ['Desconocido', 'sunny'];
};
